// eslint-disable-next-line import/prefer-default-export
export const CANCELLABLE_REQUEST_ID = 'cancellableRequestId'
